// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3zbTm","btnRed":"styles_btnRed__3QV6s","container":"styles_container__32agv","group":"styles_group__b5n5b","text":"styles_text__OC7mL"};